import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import {
    ordersSetFilterTime,
    ordersSetFilterPrice,
    ordersSetFilterGroup,
    ordersSetFilterSearch
} from './../store/ordersFind/actions';
import { capitalize } from './../utils/text';

import Dropdown from './Dropdown';
import Select from './Select';
import Range from './Range';
import Icon from './Icon';
import SubjectsSearchForm from './SubjectsSearchForm';
import TypesSearchForm from './TypesSearchForm';
import OrdersTableSearch from './OrdersTableSearch';

class OrdersTableFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchValue: ''
        };

        this.onToggleSearchClick = this.onToggleSearchClick.bind(this);
        this.onSearchSubmit = this.onSearchSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount() {
        const { setFilterSearch } = this.props;
        setFilterSearch('');
    }

    onSearchSubmit(event) {
        event.preventDefault();
        const { searchValue } = this.state;
        const { setFilterSearch } = this.props;
        setFilterSearch(searchValue.trim());
    }

    onToggleSearchClick() {
        const { setFilterSearch, isSearch, onSearchChange } = this.props;
        this.setState(state => {
            const newIsSearch = !isSearch;
            if (!newIsSearch) {
                setFilterSearch('');
            }
            onSearchChange(newIsSearch);
        });
    }

    onInputChange(event) {
        const target = event.target;
        this.setState(state => Object.assign({}, state, {
            [target.name]: target.value
        }));
    }

    render() {
        const {
            translate,
            typeId,
            className,
            filter,
            orderTimes,
            writerGroups,
            setFilterTime,
            setFilterPrice,
            setFilterGroup,
            isSearch
        } = this.props;
        const { searchValue } = this.state;

        if (isSearch) {
            return (
                <div className={className}>
                    <OrdersTableSearch
                        onSubmit={this.onSearchSubmit}
                        value={searchValue}
                        onChange={this.onInputChange}
                        onToggleClick={this.onToggleSearchClick}
                    />
                </div>
            );
        }

        return (
            <div className={className}>
                <div className="row">
                    <div className="col-1">
                        <button type="button" className="btn btn-filter-search" onClick={this.onToggleSearchClick}><Icon className="svg-icon" iconName="search" /></button>
                    </div>
                    <div className="col-4">
                        <Dropdown text={translate(`timeFilter.${filter.time}`)} closeAlways>
                            <Select className="menu menu-selectable" onChange={setFilterTime} value={filter.time}>
                                {orderTimes.map(item =>
                                    <li key={item} value={item} className="menu-item">{translate(`timeFilter.${item}`)}</li>
                                )}
                            </Select>
                        </Dropdown>
                    </div>
                    <div className="col-4 pos-static">
                        <Dropdown text={filter.subject.length ? 'Custom subjects' : 'All subjects'} fluid>
                            <SubjectsSearchForm typeId={typeId} />
                        </Dropdown>
                    </div>
                    <div className="col-4">
                        <Dropdown text={filter.type.length ? 'Custom types' : 'All types'}>
                            <TypesSearchForm typeId={typeId} />
                        </Dropdown>
                    </div>
                    <div className="col-4">
                        <Dropdown text={capitalize(filter.group) || 'All groups'} closeAlways>
                            <Select className="menu menu-selectable" onChange={setFilterGroup} value={filter.group}>
                                {writerGroups.map(item =>
                                    <li key={item} value={item} className="menu-item">{capitalize(item) || 'All groups'}</li>
                                )}
                            </Select>
                        </Dropdown>
                    </div>
                    <div className="col-8" />
                    <div className="col-8">
                        {filter.priceStep > 0 &&
                            <Range
                                min={filter.priceBoundMin}
                                max={filter.priceBoundMax}
                                value={[filter.priceMin, filter.priceMax]}
                                onChange={setFilterPrice}
                                step={filter.priceStep} />
                        }
                    </div>
                    <div className="col-2">
                        {filter.priceStep > 0 &&
                            <div className="lablе-box">
                                <span className="lablе-box_from">${filter.priceMin}</span>{' - '}<span className="lablе-box_to">${filter.priceMax}</span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    const translate = getTranslate(state.locale);
    const filter = state.ordersFind.filter[ownProps.typeId];
    const orderTimes = state.settings.orderTimesWithNew;
    const writerGroups = state.settings.writerGroups;
    return { filter, orderTimes, writerGroups, translate };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setFilterTime: value => dispatch(ordersSetFilterTime(ownProps.typeId, value)),
        setFilterPrice: ([min, max]) => dispatch(ordersSetFilterPrice(ownProps.typeId, min, max)),
        setFilterSearch: value => dispatch(ordersSetFilterSearch(ownProps.typeId, value)),
        setFilterGroup: value => dispatch(ordersSetFilterGroup(ownProps.typeId, value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersTableFilter);



// WEBPACK FOOTER //
// ./src/components/OrdersTableFilter.js